export const mapearDadosFormularioProjeto = (ctx) => ({
    // =========================
    // PROJETO
    // =========================
      sqProjetoVar: ctx.sqProjetoVar,
      numeroProjeto: ctx.numeroProjeto,
      statusProjeto: ctx.statusProjeto,
      safra: ctx.selecaoSafra?.name ?? null,
      projetoUnicampo: ctx.selecaoProjeto?.name ?? null,
      tipoProjeto: ctx.selecaoTipoProjeto?.name ?? null,
      linhaCredito: ctx.selecaoLinhaCredito?.name ?? null,
      itemAgropecuario: ctx.selecaoItemAgropecuario?.name ?? null,
      areaHa: ctx.areaHa,

    // =========================
    // COOPERADO
    // =========================
      cdPessoa: ctx.selecaoCooperado?.value ?? null,
      nmRazao: ctx.selecaoCooperado?.name ?? null,

    // =========================
    // CLIENTE RURAL
    // =========================
      nomeClienteRural: ctx.selecaoClienteRural?.name ?? null,
      cpfCnpj: ctx.selecaoClienteRural?.cpfCnpj ?? null,

    // =========================
    // LOCALIZAÇÃO
    // =========================
      municipioUf: ctx.selecaoMunicipio?.name ?? null,

    // =========================
    // FINANCEIRO
    // =========================
      valorOrcado: ctx.vlOrcado,
      percentualAstec: ctx.perAstec,
      valorAstec: ctx.vlAstec,
      valorLiberado: ctx.vlLiberado,

    // =========================
    // DATAS
    // =========================
      dataProjeto: formatarDataBr(ctx.dataProjeto),
      dataVencimento: formatarDataBr(ctx.dataVencBoleto),

    // =========================
    // PIX
    // =========================
      qrCodeImage: ctx.qrCodeImage,
      copiaCola: ctx.textAreaData,

    // =========================
    // OPERAÇÃO
    // =========================
      numeroOperacao: ctx.nOperacao,
      instituicaoFinanceira: ctx.selecaoInstituicaoFinanceira?.name ?? null,
      agencia: ctx.selecaoAgencia?.name ?? null,
});

function formatarDataBr(data) {
  if (!data) return null;
  const dataLimpa = data.split(" ")[0];
  const [ano, mes, dia] = dataLimpa.split("-");
  return `${dia}/${mes}/${ano}`;
}
